/* Components */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/common/Header";
import Icon from "../../components/common/Icon";
import GalleryHeader from "../../components/common/GalleryHeader";
import {getAgencyHeader} from "../../api/pro/agencyReq";
import useAuth from "../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import {getEstimateSectionList} from "../../api/admin/estimateReq";
import {
    deleteEstimateFromDb, getEstimateCategoryEnabledList,
    getEstimateCategoryListCount,
    getEstimateContent,
    getEstimateFullList,
    getEstimateList
} from "../../api/pro/estimateReq";
import FormEditEstimate from "../../forms/tools/FormEditEstimate";


export default function DevisTypes() {
    const sources = "fa fa-file-invoice";
    const navigate = useNavigate();
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const agencyId = decodedToken.agency;
    const [ agencyHeader, setAgencyHeader ] = useState();
    const [ estimateCategoryList, setEstimateCategoryList ] = useState([]);
    const [ estimateList, setEstimateList ] = useState([]);
    const [ estimateCount, setEstimateCount ] = useState([]);
    const [total, setTotal] = useState(0);
    const [ estimateContentInfos, setEstimateContentInfos ] = useState();
    const [ estimateFullContent, setEstimateFullContent ] = useState();
    const [ headerInfos, setHeaderInfos ] = useState({
        headerId: 0,
        headerName: "",
        categoryId: 0,
        headerType: "",
    });
    const [ estimateSectionList, setEstimateSectionList ] = useState();
    const [ showModal, setShowModal ] = useState(false);
    const apiAgencyHeader = async () => {
        const response = await getAgencyHeader(token, agencyId)
        setAgencyHeader(response)
    };

    const apiEstimateCategoryList = async () => {
        const response = await getEstimateCategoryEnabledList(token)
        setEstimateCategoryList(response)
    }

    const apiEstimateList = async () => {
        const response = await getEstimateList(token, agencyId)
        setEstimateList(response)
        await apiEstimateCount()
    }

    const apiEstimateCount = async () => {
        const response = await getEstimateCategoryListCount(token, agencyId)
        setEstimateCount(response)
    }

    const apiEstimateContentByHeader = async (id) => {
        const response = await getEstimateContent(token, id, agencyId)
        setEstimateContentInfos(response)
        setShowModal(true)
    }

    const apiEstimateSectionList = async () => {
        const response = await getEstimateSectionList(token)
        setEstimateSectionList(response)
    }

    const apiEstimateFullList = async () => {
        const response = await getEstimateFullList(token)
        setEstimateFullContent(response)
    }

    const handleEditEstimate = (estimateId, headerName, code, type) => {
        setHeaderInfos({
            headerId: estimateId,
            headerName: headerName,
            categoryId: code,
            headerType: type,
        })
        apiEstimateContentByHeader(estimateId)
    }

    useEffect(() => {
        apiAgencyHeader()
        apiEstimateList()
        apiEstimateCount()
    }, [ agencyId ]);

    useEffect(() => {
        apiEstimateCategoryList()
        apiEstimateSectionList()
    }, [ token ]);

    const handleAddEstimate = (code) => {
        setHeaderInfos({
            headerId: 0,
            headerName: "",
            categoryId: code,
            headerType: "",
        })
        apiEstimateFullList()
        setShowModal(true)
    }


    const handleDeleteEstimate = async (id) => {
        let body = {
            headerId: id
        }
        if (window.confirm("Voulez-vous vraiment supprimer ce devis ?")) {
            await deleteEstimateFromDb(token, body)
            await apiEstimateList()
        }
    }

    useEffect(() => {
        setTotal(estimateCount?.lowCostTotal + estimateCount?.mediumCostTotal + estimateCount?.highCostTotal)
    }, [ estimateCount ]);

    return (
        <main>
            <Header
                location="Devis type"
                parent="Tableau de bord"
                slug="/"
            />
            { showModal &&
                <div className="modal edit-estimate">
                    <FormEditEstimate
                        apiEstimateList={apiEstimateList}
                        estimateList={estimateList}
                        headerInfos={headerInfos}
                        setShowModal={setShowModal}
                        estimateContentInfos={headerInfos?.headerId == 0 ? estimateFullContent : estimateContentInfos}
                        sections={estimateSectionList}
                        legend="Modifier le devis type"
                        setEstimateCount={setEstimateCount}
                    />
                </div>
            }
            <div className="content-container">
                <Icon source={sources} color="blue" span="Gestion des devis type"/>
                <div className="gallery">
                    {/*<GalleryHeader data={agencyHeader}/>*/}
                    <h3>Devis type (<span>{total.toString()}</span> / 6)</h3>
                    {estimateCategoryList?.length > 0 && estimateCategoryList?.map((category, index) => {
                        const categoryEstimates = estimateList?.filter(estimate => estimate?.categoryId == category?.id) || [];
                        const categoryTotal = category?.code == 1
                            ? estimateCount?.lowCostTotal
                            : category?.code == 2
                                ? estimateCount?.mediumCostTotal
                                : category?.code == 3
                                    ? estimateCount?.highCostTotal
                                    : 0;
                        const canAddEstimate = categoryTotal < 2;

                        return (
                        <table key={index} className="devis-table">
                            <thead className="dashboard-header">
                                <tr>
                                    <th>{category?.description} (<span>{categoryTotal} / 2</span>)
                                    </th>
                                    <th>Type</th>
                                    <th>Montant TTC</th>
                                    <th><i className="fa fa-gear"/></th>
                                </tr>
                            </thead>
                            <tbody>
                            {categoryEstimates.map((estimate, index2) => (
                                <tr key={index2} className="category-content">
                                    <td>
                                        <span>{estimate?.headerName}</span>
                                    </td>
                                    <td>
                                        <span>{estimate?.headerType == "I" ? "Inhumation" : "Crémation"}</span>
                                    </td>
                                    <td>
                                        <span>{estimate?.headerAmount}</span>
                                    </td>
                                    <td>
                                        <div className="actions">
                                            <i className="fa fa-pen-to-square" onClick={() => handleEditEstimate(estimate?.headerId, estimate?.headerName, category?.id, estimate?.headerType)}/>
                                            {(canAddEstimate && index2 === categoryEstimates.length - 1) &&
                                                <i className="fa fa-plus add-devis-btn" onClick={() => handleAddEstimate(category?.code)} title="Ajouter un devis"/>
                                            }
                                            <i className="fa fa-trash" onClick={() => handleDeleteEstimate(estimate?.headerId)}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {(canAddEstimate && categoryEstimates.length === 0) &&
                                <tr className="category-content">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <div className="actions">
                                            <i className="fa fa-plus add-devis-btn" onClick={() => handleAddEstimate(category?.code)} title="Ajouter un devis"/>
                                        </div>
                                    </td>
                                </tr>
                            }
                            </tbody>
                        </table>
                        );
                    })}
                    <div className="back-button-container">
                        <button onClick={() => navigate(-1)}><i className="fa fa-arrow-left"></i> <span>Retour</span></button>
                    </div>
                </div>
            </div>
        </main>
    )
}